import React from "react";
import { withTranslation } from "react-i18next";
import { Timeline, TimelineEvent } from "react-event-timeline";

function CaseHistory(props) {
  //   let dataTable = props.caseHistories.map((caseHistory) => (
  //     <tr key={caseHistory.tas_uid}>
  //       <td>{caseHistory.tas_title}</td>
  //       <td>
  //         {caseHistory.delegations[0] != null
  //           ? caseHistory.delegations[0].usr_firstname +
  //             " " +
  //             caseHistory.delegations[0].usr_lastname
  //           : ""}
  //       </td>
  //       <td>
  //         {caseHistory.delegations[0] != null
  //           ? caseHistory.delegations[0].del_init_date
  //           : ""}
  //       </td>
  //       <td>
  //         {caseHistory.delegations[0] != null
  //           ? caseHistory.delegations[0].del_finish_date === "Not finished"
  //             ? props.t("Not finished")
  //             : caseHistory.delegations[0].del_finish_date
  //           : ""}
  //       </td>
  //     </tr>
  let dataTable = props.caseHistories.map((caseHistory) => (
    <TimelineEvent
      key={caseHistory.tas_uid}
      title={caseHistory.tas_title}
      // createdAt= {caseHistory.delegations[0] != null
      //     ? caseHistory.delegations[0].del_init_date
      //     : ""}
      icon={props.t("Task")}
      iconColor="black"
      titleStyle={{ fontWeight: 'bold' }}
    >
      {props.t("Delegated User")}:
      <p>
        <i className="fas fa-user fa-fw"> </i>
        {caseHistory.delegations[0] != null
          ? caseHistory.delegations[0].usr_firstname +
            " " +
            caseHistory.delegations[0].usr_lastname
          : ""}
      </p>
      {props.t("START DATE")}:
      <p>
        <i className="fas fa-calendar-day fa-fw"> </i>
        {caseHistory.delegations[0] != null
          ? caseHistory.delegations[0].del_init_date
          : ""}
      </p>
      {props.t("End Date")}:
      <p>
        <i className="fas  fa-calendar-week fa-fw"> </i>
        {caseHistory.delegations[0] != null
          ? caseHistory.delegations[0].del_finish_date === "Not finished"
            ? props.t("Not finished")
            : caseHistory.delegations[0].del_finish_date
          : ""}
      </p>
    </TimelineEvent>
  ));

  return (
    // <div>
    //   <table className="table table-bordered">
    //     <thead>
    //       <tr>
    //         <th>{props.t("Task")}</th>
    //         <th>{props.t("Delegated User")}</th>
    //         <th>{props.t("START DATE")}</th>
    //         <th>{props.t("End Date")}</th>
    //       </tr>
    //     </thead>
    //     <tbody>{dataTable}</tbody>
    //   </table>
    // </div>
    <Timeline
      orientation="right"
       lineColor="#fcab03"
    >
      {dataTable}
    </Timeline>
  );
}

export default withTranslation()(CaseHistory);
